export default {
    privateLabelTitle: "Desenvolva a sua marca própria connosco",
    privateLabelDescription:
        "Desenvolva sua marca própria com a Noritex, empresa com mais de 50 anos de experiência no desenvolvimento de marcas próprias.",
    title: "Nossos produtos",
    products: ["Casa", "Escola", "Bem estar", "Natal", "Têxtil", "Religioso"],
    formTitle: "Contate-Nos",
};
